import React, { Component } from 'react';
import config from './../../../config';
import { connect } from 'react-redux';
import { navigation_close_on_submit } from './../../../redux/reducers/navigationSlice';
import FormatText from '../../../helpers/FormatTitle';
import { trimTrailingSlash } from '@emarketer/code-helpers';
import { premiumForecasts } from '../../../redux/reducers/premiumSlice';
import PremiumPopper from '../../PremiumTag/PremiumPopper';

function mapStateToProps(state, ownProps) {
   return {
      CollectionName: state.collection.name,
      SelectedGeography: state.navigation.selectedGeography
   };
}

const mapDispatchToProps = (dispatch, ownProps) => {
   return {
      onClick: (templateId, SelectedTemplateId) => {
         if (SelectedTemplateId !== templateId) {
            dispatch(navigation_close_on_submit());
         }
      }
   };
};

class NavCollection extends Component<
   {
      CollectionName: string;
      CollectionType: string;
      SelectedTemplateId: string;
      SelectedGeography: string;
      id: string;
      templateid: string;
      name: string;
      channelTitle: string;
      onClick: (templateId: string, SelectedTemplateId: string) => void;
      navToggleClose: () => void;
   },
   {}
> {
   constructor(props) {
      super(props);
      this.onClick = this.onClick.bind(this);
   }

   private onClick() {
      this.props.onClick(this.props.templateid, this.props.SelectedTemplateId);
   }

   public render() {
      const { SelectedGeography, CollectionName, name, channelTitle, id, templateid } = this.props;

      const collectionLinkStyles = () => {
         const isActive = CollectionName === name ? 'active' : '';
         return `${isActive}`;
      };

      const isCollectionPremium = () => {
         return premiumForecasts.some(f => f.collectionId === id);
      };

      const analyticTag = `Forecasts-Navigation-${FormatText(SelectedGeography)}-${FormatText(channelTitle)}-${id}`;
      const templatePath = templateid ? `/${templateid}` : '';
      const url = `${trimTrailingSlash(config.publicPath)}/${id}${templatePath}`;

      return (
         <li>
            <a data-analytics={analyticTag} className={collectionLinkStyles()} href={url} onClick={this.onClick}>
               {name}
               {config.enableNonPremiumFeatures && isCollectionPremium() && <PremiumPopper />}
            </a>
         </li>
      );
   }
}

export default connect(mapStateToProps, mapDispatchToProps)(NavCollection);
